<template>
	<router-view style="background-color: white;" :key="$route.path + $route.query.t" />
</template>
<script>
	export default {
		name: 'App',
		data() {
			return {
			}
		},
		computed: {
			
			
		},
		methods: {
		},
		mounted() {
		},

	}
</script>

<style lang="less">
	*{
		margin:0px;
		padding:0px;
	}
	body,html{
		font-family: 'HarmonyOS Sans SC';
		
		height:100%;
	}
	
</style>
